import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { colorSubText } from "../../../theme";

interface MarcasFilterCardProps {
  marcas: string[];
  selected: string[];
  onChange: (selected: string[]) => void;
}

export function MarcasFilterCard({
  marcas,
  selected,
  onChange,
}: MarcasFilterCardProps) {
  const handleToggle = (marca: string) => {
    if (selected.includes(marca)) {
      onChange(selected.filter((m) => m !== marca));
    } else {
      onChange([...selected, marca]);
    }
  };

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        p: 2,
        borderRadius: 3,
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      {/* Título */}
      <Box mb={2}>
        <Typography
          fontWeight={700}
          fontSize="0.7rem"
          letterSpacing={1.5}
          textTransform="uppercase"
          color="text.secondary"
        >
          Marcas
        </Typography>

        <Box
          sx={{
            width: 32,
            height: 4,
            bgcolor: "primary.main",
            mt: 0.5,
            borderRadius: 2,
          }}
        />
      </Box>

      {/* Lista rolável */}
      <Box
        sx={{
          maxHeight: 192, // equivalente a max-h-48
          overflowY: "auto",
          pr: 1,

          // esconde scrollbar (opcional)
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "transparent",
          },
        }}
      >
        <Box display="flex" flexDirection="column" gap={2}>
          {marcas.map((marca) => (
            <FormControlLabel
              key={marca}
              control={
                <Checkbox
                  checked={selected.includes(marca)}
                  onChange={() => handleToggle(marca)}
                  color="primary"
                />
              }
              label={
                <Typography
                  fontSize="0.85rem"
                  color={colorSubText}
                  fontWeight={600}
                  sx={{
                    transition: "color 0.2s ease",
                  }}
                >
                  {marca.charAt(0).toUpperCase() + marca.slice(1).toLocaleLowerCase()}
                </Typography>
              }
              sx={{
                ml: 0,
                cursor: "pointer",
                "&:hover .MuiTypography-root": {
                  color: "primary.main",
                },
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
